export default "__VITE_ASSET__CMCArawA__"